// extracted by mini-css-extract-plugin
export default {"auth-layout":"AuthLayout_auth-layout__nP91e","auth-content":"AuthLayout_auth-content__gIqdu"};